// Sidebar dropdown actions for channels, DMs, and group DMs.
import { getSDK } from '../sdk.js'

// ── Rename channel or group DM ──
export const renameChannel = async function (channelId, newName) {
  const root = this?.state?.root
  if (!root || !channelId || !newName) return
  try {
    // migrated 2026-04-27 to SDK route workspaceProject.chat update
    await getSDK().execute('workspaceProject.chat', 'update', {
      id: channelId,
      payload: { name: newName }
    })
  } catch (err) {
    console.error('[renameChannel]', err)
    return
  }
  root.update({
    channels: (root.channels || []).map(c =>
      c.id === channelId ? { ...c, name: newName } : c
    )
  })
}

// ── Hide DM — remove from sidebar without deleting ──
export const hideDM = async function (channelId) {
  const root = this?.state?.root
  if (!root || !channelId) return
  const me = root.currentUserEmail
  // Optimistic: remove from local channels list
  const hiddenSet = new Set(root._hiddenChannels || [])
  hiddenSet.add(channelId)
  root.update({
    _hiddenChannels: Array.from(hiddenSet),
    activeChannelId: root.activeChannelId === channelId ? null : root.activeChannelId
  })
}

// ── Leave channel / group DM ──
export const leaveChannel = async function (channelId) {
  const root = this?.state?.root
  if (!root || !channelId) return
  const me = root.currentUserEmail
  try {
    // migrated 2026-04-27 to SDK route workspaceProject.chat.members remove
    await getSDK().execute('workspaceProject.chat.members', 'remove', {
      channelId,
      userId: me
    })
  } catch (err) {
    console.error('[leaveChannel]', err)
    return
  }
  root.update({
    channelMembers: (root.channelMembers || []).filter(
      m => !(m.channel_id === channelId && m.member_email === me)
    ),
    channels: (root.channels || []).filter(c => c.id !== channelId),
    activeChannelId: root.activeChannelId === channelId ? null : root.activeChannelId
  })
}

// ── Pin to top — toggle pinned, persisted in localStorage ──
const _PINNED_KEY = 'chat_pinned_channels'
const _loadPinned = () => {
  try { return JSON.parse(localStorage.getItem(_PINNED_KEY) || '[]') } catch { return [] }
}
const _savePinned = (ids) => {
  try { localStorage.setItem(_PINNED_KEY, JSON.stringify(ids)) } catch { /* noop */ }
}

export const pinToTop = function (channelId) {
  const root = this?.state?.root
  if (!root || !channelId) return
  const current = new Set(_loadPinned())
  if (current.has(channelId)) current.delete(channelId)
  else current.add(channelId)
  const arr = Array.from(current)
  _savePinned(arr)
  root.update({ _pinnedChannels: arr })
}

// Load pinned channels from localStorage into state on init
export const loadPinnedChannels = function () {
  const root = this?.state?.root
  if (!root) return
  root.update({ _pinnedChannels: _loadPinned() })
}

// ── Invite — open the new-channel modal prefilled with the channel ──
export const inviteToChannel = function (channelId) {
  const root = this?.state?.root
  if (!root || !channelId) return
  const ch = (root.channels || []).find(c => c.id === channelId)
  if (!ch) return
  root.update({
    showChannelSettings: channelId,
    channelSettingsTab: 'members'
  })
}

// ── Channel settings — open settings modal ──
export const openChannelSettings = function (channelId) {
  const root = this?.state?.root
  if (!root || !channelId) return
  root.update({ showChannelSettings: channelId })
}

// ── Start group chat from a DM — open new channel modal prefilled ──
export const startGroupChat = function (channelId) {
  const root = this?.state?.root
  if (!root || !channelId) return
  const me = root.currentUserEmail
  const members = (root.channelMembers || [])
    .filter(m => m.channel_id === channelId && m.member_email !== me)
    .map(m => m.member_email)
  root.update({
    showNewChannel: true,
    newChannelDraft: {
      kind: 'dm',
      name: '',
      topic: '',
      members,
      is_private: false
    }
  })
}

// ── Convert group DM to channel ──
export const convertToChannel = function (channelId) {
  const root = this?.state?.root
  if (!root || !channelId) return
  const me = root.currentUserEmail
  const members = (root.channelMembers || [])
    .filter(m => m.channel_id === channelId && m.member_email !== me)
    .map(m => m.member_email)
  root.update({
    showNewChannel: true,
    newChannelDraft: {
      kind: 'channel',
      name: '',
      topic: '',
      members,
      is_private: false
    }
  })
}
